module.exports = __webpack_public_path__ + "static/media/sss-auto-plus.6c472285.svg";